import Button from './button';
import Link from './link';
import Popover from './popover';

const components = {
  ...Button,
  ...Link,
  ...Popover,
};

export default components;
